module.exports = __webpack_public_path__ + "static/media/referralBanner.bc6d069d.jpg";